import type { PortalMission } from '@/features/portal/types';
import { currentMonth, shiftMonth } from './timesheet-labels';

export const todayKey = (): string => {
  const now = new Date();
  return `${currentMonth()}-${String(now.getDate()).padStart(2, '0')}`;
};

/** Un CRA par mission et par mois, uniquement sur une période de mission commencée. */
export const missionMonths = (
  mission: Pick<PortalMission, 'startDate' | 'endDate'>,
  today = todayKey(),
): string[] => {
  if (mission.startDate > today) return [];
  const first = mission.startDate.slice(0, 7);
  const last = (mission.endDate && mission.endDate < today ? mission.endDate : today).slice(0, 7);
  const months: string[] = [];
  for (let month = last; month >= first; month = shiftMonth(month, -1)) months.push(month);
  return months;
};

export const defaultMissionMonth = (months: string[], today = todayKey()): string => {
  const previous = shiftMonth(today.slice(0, 7), -1);
  return months.includes(previous) ? previous : (months[0] ?? '');
};

export const formatMissionDate = (date: string): string =>
  new Date(`${date}T12:00:00`).toLocaleDateString('fr-FR');
